export default "__VITE_ASSET__CZM6bgiJ__"